// source: pbtypes/gen/vehicle_updates/transfer_rate.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var pbtypes_gen_vehicle_attributes_soc_type_pb = require('../../../pbtypes/gen/vehicle_attributes/soc_type_pb.js');
goog.object.extend(proto, pbtypes_gen_vehicle_attributes_soc_type_pb);
goog.exportSymbol('proto.vehicle_updates.TransferRate', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vehicle_updates.TransferRate = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vehicle_updates.TransferRate, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vehicle_updates.TransferRate.displayName = 'proto.vehicle_updates.TransferRate';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vehicle_updates.TransferRate.prototype.toObject = function(opt_includeInstance) {
  return proto.vehicle_updates.TransferRate.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vehicle_updates.TransferRate} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vehicle_updates.TransferRate.toObject = function(includeInstance, msg) {
  var f, obj = {
soc: jspb.Message.getFieldWithDefault(msg, 1, 0),
downloadRateKbps: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vehicle_updates.TransferRate}
 */
proto.vehicle_updates.TransferRate.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vehicle_updates.TransferRate;
  return proto.vehicle_updates.TransferRate.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vehicle_updates.TransferRate} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vehicle_updates.TransferRate}
 */
proto.vehicle_updates.TransferRate.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.vehicle_attributes.SocType} */ (reader.readEnum());
      msg.setSoc(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setDownloadRateKbps(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vehicle_updates.TransferRate.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vehicle_updates.TransferRate.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vehicle_updates.TransferRate} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vehicle_updates.TransferRate.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSoc();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getDownloadRateKbps();
  if (f !== 0.0) {
    writer.writeFloat(
      2,
      f
    );
  }
};


/**
 * optional vehicle_attributes.SocType soc = 1;
 * @return {!proto.vehicle_attributes.SocType}
 */
proto.vehicle_updates.TransferRate.prototype.getSoc = function() {
  return /** @type {!proto.vehicle_attributes.SocType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.vehicle_attributes.SocType} value
 * @return {!proto.vehicle_updates.TransferRate} returns this
 */
proto.vehicle_updates.TransferRate.prototype.setSoc = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional float download_rate_kbps = 2;
 * @return {number}
 */
proto.vehicle_updates.TransferRate.prototype.getDownloadRateKbps = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.vehicle_updates.TransferRate} returns this
 */
proto.vehicle_updates.TransferRate.prototype.setDownloadRateKbps = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


goog.object.extend(exports, proto.vehicle_updates);
